import React from 'react'
import { styled } from '@mui/material/styles'
import { useRouter } from 'next/router'
import TreeView from '@mui/lab/TreeView'
import AddIcon from '@mui/icons-material/Add'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import Label from '@mui/icons-material/Label'
import { StyledTreeItem } from '@components/molecules/StyledTreeItem'
import { FirstDepthCatalogCategoryFragment } from '@services/cloud/client'

const PREFIX = 'FirstDepthTreeView'

const classes = {
  root: `${PREFIX}-root`,
}

const StyledTreeView = styled(TreeView)(({ theme }) => ({
  [`&.${classes.root}`]: {
    flexGrow: 1,
    maxWidth: 400,
    paddingRight: theme.spacing(2),
  },
}))

type Props = {
  firstDepthCategory: FirstDepthCatalogCategoryFragment | null | undefined
}

export function FirstDepthTreeView(props: Props) {
  const router = useRouter()

  return (
    <StyledTreeView
      className={classes.root}
      defaultExpanded={['1']}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
    >
      <StyledTreeItem
        nodeId="1"
        labelText="カテゴリー"
        labelIcon={Label}
        onClick={() => router.push('/catalogs')}
      >
        {props.firstDepthCategory?.secondDepthCategories?.map((category) => (
          <StyledTreeItem
            key={`${category?.categoryId}`}
            nodeId={`${category?.categoryId}`}
            labelText={`${category?.name}`}
            labelInfo={`(${category?.length})`}
            labelIcon={AddIcon}
            onClick={() =>
              router.push(
                `/catalogs/category/${props.firstDepthCategory?.categoryId}/${category?.categoryId}`,
              )
            }
          />
        ))}
      </StyledTreeItem>
    </StyledTreeView>
  )
}
